import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import {
  AlertModal,
  DynamicButton,
  StyledText,
} from "../../../../components/common";
import { useTheme } from "../../../../hooks";

const AccraForm = ({
  selectedLocation,
  setLocation,
  setModeOfAttendance,
  modeOfAttendance,
}) => {
  const citiesAccra = [
    { label: "Airport City", value: "Airport City" },
    { label: "Airport Residential Area", value: "Airport Residential Area" },
    { label: "Dzorwulu", value: "Dzorwulu" },
    { label: "Abelemkpe", value: "Abelemkpe" },
    { label: "Madina", value: "Madina" },
    { label: "37 Military Hospital", value: "37 Military Hospital" },
    { label: "Burma Camp", value: "Burma Camp" },
    { label: "Cantonments", value: "Cantonments" },
    { label: "Osu", value: "Osu" },
    { label: "Labone", value: "Labone" },
    { label: "Ridge", value: "Ridge" },
  ];

  const modeOfAttendanceAccra = [
    { label: "In-Person", value: "In-Person" },
    { label: "Online", value: "online" },
  ];

  return (
    <div>
      <StyledText>Attendance Type</StyledText>
      <Select
        onChange={({ target }) => setModeOfAttendance(target.value)}
        value={modeOfAttendance}
        placeholder="Select Attendance Type"
      >
        <option value="" disabled>
          Attendance type
        </option>
        {modeOfAttendanceAccra.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>

      {modeOfAttendance === "In-Person" && (
        <>
          <StyledText>Select your location</StyledText>
          <Select
            onChange={({ target }) => setLocation(target.value)}
            value={selectedLocation}
          >
            <option value="" disabled>
              Select your location
            </option>
            {citiesAccra.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Select>
        </>
      )}
    </div>
  );
};

const OtherRegionsForm = () => {
  return (
    <div>
      <StyledText
        size={12}
        style={{ fontFamily: "MTNRegular", marginBottom: "20px" }}
      >
        Please proceed with online registration.
      </StyledText>
      <Select disabled defaultValue="online">
        <option value="online">Online</option>
      </Select>
    </div>
  );
};

const LocationSelector = ({
  setLocation,
  selectedLocation,
  regionSelected,
  setModeOfAttendance,
  modeOfAttendance,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const history = useHistory();

  // Show the alert only when the region is not Greater Accra
  useEffect(() => {
    if (regionSelected && regionSelected !== "Greater Accra") {
      setShowAlert(true);
    }
  }, [regionSelected]);

  // Confirm the online attendance mode
  const handleConfirmOnline = () => {
    console.log(modeOfAttendance);

    setModeOfAttendance("online");
    setShowAlert(false);
  };

  const handleGoHome = () => {
    setShowAlert(false);
    history.push("/digital-skills-training");
  };

  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <div>
      {regionSelected === "Greater Accra" ? (
        <AccraForm
          selectedLocation={selectedLocation}
          setLocation={setLocation}
          setModeOfAttendance={setModeOfAttendance}
          modeOfAttendance={modeOfAttendance} // Pass modeOfAttendance to AccraForm
        />
      ) : (
        <OtherRegionsForm setModeOfAttendance={setModeOfAttendance} />
      )}

      {showAlert && (
        <AlertModal onClick={() => setShowAlert(false)} success={false}>
          <div>
            <StyledText size={18} style={{ marginBottom: "15px" }}>
              In-person attendance is not available in your location.
            </StyledText>
            <StyledText
              size={12}
              style={{ fontFamily: "MTNRegular", marginBottom: "30px" }}
            >
              Would you like to continue with online attendance?
            </StyledText>

            <DynamicButton
              onClick={handleConfirmOnline}
              label="Yes, Continue"
              color={background}
              fullWidth
            />
            <DynamicButton
              onClick={handleGoHome}
              label="No, Go Home"
              variant="outlined"
              fullWidth
              color={background}
            />
          </div>
        </AlertModal>
      )}
    </div>
  );
};

export default LocationSelector;

const Select = styled.select`
  border-radius: 5px;
  margin-bottom: 20px;
  font-family: "MTNRegular";
  padding: 10px;
  width: 100%;
  height: 45px;
  background-color: white;
`;
